import script from "./agentPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./agentPopup.vue?vue&type=script&setup=true&lang=ts"

import "./agentPopup.vue?vue&type=style&index=0&id=622c6588&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-622c6588"]])

export default __exports__